import styled from '@emotion/styled';
import { mq } from '@styles/helpers';
import { Devices } from '@styles/tokens';

export const ContainerSpan = styled.div`
    background:#fff;
    border-radius: 8px;
    box-shadow: 0 0 2px 1px rgba(0,0,0,0.1);
    padding:20px;
        grid-row: 1 / span 2;
        grid-row-start: 2;
`;
export const Container = styled.div`
    background:#fff;
    border-radius: 8px;
    box-shadow: 0 0 2px 1px rgba(0,0,0,0.1);
    padding:20px;
    height:340px;
`;

export const Title = styled.span`
    font-size: 18px;
    color:#5e5e5e;
    display:block;
    font-weight: 500;
`;

export const SubTitle = styled.span`
    font-size: 14px;
    line-height: 16px;
    color:#5e5e5e;
    display:block;
`;


export const ListContainer = styled.div`
    display:flex;
    flex-direction: column;
    width:100%;
    gap:8px;
    max-height:calc(100vh - 340px);
    overflow-y: auto;
    margin-top: 20px;
    padding:2px;
`;

export const Item = styled.div`
    display:flex;
    align-items: center;
    background:#f7f7f7;
    padding:8px 12px;
    border-radius: 8px;
    transition: all 0.1s ease-in-out;
    gap:10px;
    box-shadow: 0 0 2px 1px rgba(0,0,0,0.1);
    
    :hover{
        background:#f0f0f0;
        cursor: pointer;
    }
`;

export const Icon = styled.div<{negative?:boolean, rewardBg?:boolean}>`
    height:34px;
    width:34px;
    background: ${props => props.rewardBg?"#e7e7e7":props.negative?"#FAE9EB":"#E1F2F5"};
    border-radius: 6px;
    display:flex;
    align-items: center;
    justify-content: center;

    svg{
        width:${props => props.rewardBg?"80%":"50%"};
        path{
            stroke:${props => props.negative?"#fa505e":"#2a848e"};
        }
    }
`;

export const InfoStart = styled.div`
    display:flex;
    flex-direction: column;

    span{
        :nth-of-type(1){
            font-weight: 500;
            font-size: 14px;
            line-height: 16px;
        }
    }
`;

export const InfoEnd = styled.div<{negative?:boolean}>`
    display:flex;
    flex-direction: column;
    align-items: end;
    margin-left: auto;

    span{
        :nth-of-type(1){
            font-weight: 500;
            font-size: 14px;
            line-height: 16px;
            color:${props => props.negative?"#fa505e":"#2a848e"};
        }
    }
`;

export const GraphContainer = styled.div`
    width:100%;
    margin-top: 20px;
    display:grid;
    grid-template-columns: 140px auto;
    align-items: center;
    padding-right: 20px;
`;

export const NumberBar = styled.div`
    border-top: 2px solid #ececec;
    display:flex;
    justify-content: space-between;

    span{
        display:flex;
        align-items: center;
        flex-direction: column;

        :nth-of-type(5){
            transform: translateX(40%);
        }
    }

    div{
        display:inline-block;
        height:6px;
        width:2px;
        background:#bebebe;
    }
`;